"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefixer/lib/utils/isPrefixedProperty.js
// module id = 165
// module chunks = 0